"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsFeaturesContainer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _productSpecsFeaturesContainerItem = _interopRequireDefault(require("./product-specs-features-container-item"));
const RowTableContainer = /*#__PURE__*/(0, _react2.styled)("table")({
  name: "RowTableContainer",
  class: "pl-rlgi05z"
});

/**
 * ProductSpecsFeaturesContainer Component.
 *
 * @param {Object} props React props
 * @param {Array} props.featuresList Array of Features Item (supports both rendered React components and plain objects)
 * @returns {React.ReactElement} Row Component
 * @public
 */

function ProductSpecsFeaturesContainer({
  featuresList
}) {
  return /*#__PURE__*/_react.default.createElement(RowTableContainer, null, /*#__PURE__*/_react.default.createElement("tbody", null, featuresList?.map((feature, i) => {
    return /*#__PURE__*/_react.default.isValidElement(feature) ? feature : /*#__PURE__*/_react.default.createElement(_productSpecsFeaturesContainerItem.default, (0, _extends2.default)({
      key: i
    }, feature));
  })));
}
ProductSpecsFeaturesContainer.propTypes = {
  featuresList: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array])
};